module.exports = __webpack_public_path__ + "static/socage-da20-a2e00e5882978a7819f8f6e611301309.jpg";